export const ROLES = {
  ADMIN:            'admin',
  DISPATCHER:       'dispatcher',
  MANAGER_EMPLOYEE: 'manager_employee',
  SIMPLE_EMPLOYEE:  'simple_employee',
  MANAGER_USER:     'manager_user',
  SIMPLE_USER:      'simple_user',
  GUEST_USER:       'guest_user',
};

export const ROLE_LABELS = {
  admin:             'ادمین',
  dispatcher:       'دیسپچر',
  manager_employee: 'مدیر کارمند',
  simple_employee:  'کارمند',
  manager_user:     'مدیر کاربر',
  simple_user:      'کاربر',
  guest_user:       'مهمان',
};

export function isEmployee(type) {
  return ['admin', 'manager_employee', 'simple_employee', 'dispatcher'].includes(type);
}

export function isUser(type) {
  return ['manager_user', 'simple_user', 'guest_user'].includes(type);
}

export function isManager(type) {
  return ['manager_employee', 'manager_user'].includes(type);
}

// Narrower than isEmployee() on purpose: the multi-tab workspace is scoped
// to actual support-staff accounts that work tickets/missions day to day.
// dispatcher already has its own dedicated queue UI (DispatcherPage) and
// acts more like an operations/admin role here, so it's deliberately
// excluded - only simple_employee/manager_employee get the workspace.
export function isWorkspaceRole(type) {
  return ['simple_employee', 'manager_employee'].includes(type);
}

export function getDashboardRoute(type) {
  if (!type) return '/';
  if (type === 'admin') return '/settings';
  if (type === 'dispatcher') return '/dispatcher';
  if (isEmployee(type)) return '/dashboard';
  return '/dashboard';
}
